import { createVNode, render, ref } from 'vue'
import ConfirmDialog from './confirmDialog.vue'

const div = document.createElement('div')
div.setAttribute('class', 'xy-dialog-wrapper')
document.body.appendChild(div)

export default ({ title, message, confirmText, cancelText, checkedText = '' }) => {
  return new Promise((resolve) => {
    const visible = ref(true)
    const vnode = createVNode(ConfirmDialog, {
      visible,
      title,
      message,
      confirmText,
      cancelText,
      checkedText,
      onConfirm: (data) => {
        visible.value = false
        render('', div)
        resolve({ type: 'confirm', data })
      },
      onCancel: () => {
        visible.value = false
        render('', div)
        resolve({ type: 'cancel' })
      }
    })
    render(vnode, div)
  })
}
